import React from 'react';
import { AppBar, Toolbar, Typography, Button } from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import useStyles from './styles';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actionsCreator } from '../../State';
import { auth } from '../../firebase';

const  Navbar = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
    const {changeUser} = bindActionCreators(actionsCreator, dispatch);
    const history = useHistory();

    const logout = async () => {
        await auth.signOut();
        changeUser(null);
        history.push('/');
        return;
    }

  return (
    <div className={classes.root}>
      <AppBar >
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
              Chat App
          </Typography>
          <Button color="inherit" onClick = {logout}>Logout <ExitToAppIcon /></Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default Navbar;